const map = require('mn-utils/map');

const STATUSES_LIST = [
  'completed',
  'pending',
  'requested',
  'failed',
  'cancelled',
  // 'sent',
  // 'expired',
];

module.exports = {
  name: 'status',
  placeholder: 'Status',
  list: map(STATUSES_LIST, (id) => ({id})),
};
